import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdrCurrencyPipe } from "./pipe/idr-currency.pipe";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalAlertSwitchComponent } from '../modules/shared/components/modal-alert-switch/modal-alert-switch.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AntDModule } from '../modules/shared/antd.module';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PaymentBankComponent } from './components/payment-bank/payment-bank.component';


@NgModule({
  declarations: [
    ModalAlertSwitchComponent,
    IdrCurrencyPipe,
    PaginationComponent,
    PaymentBankComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    AntDModule,
    ReactiveFormsModule,
  ],
  exports: [
    ModalAlertSwitchComponent,
    IdrCurrencyPipe,
    PaginationComponent,
    PaymentBankComponent
  ]
})
export class LibsModule { }
